// common functions

import { getAuthToken } from "../../../utils/AuthToken";
import { errorNotify } from "../../notify/toastify";

export const time_to_second = (time) => {
  if (time == null) return 0;
  if (typeof time === "number") return time;

  const s = String(time).trim().replace(",", ".");
  if (!s) return 0;

  if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);

  const arr = s.split(":").map((x) => x.trim());
  const last = parseFloat(arr[arr.length - 1]);
  if (Number.isNaN(last)) return 0;

  if (arr.length === 2)
    return (parseInt(arr[0], 10) || 0) * 60 + last;

  if (arr.length === 3)
    return (parseInt(arr[0], 10) || 0) * 3600 +
      (parseInt(arr[1], 10) || 0) * 60 +
      last;

  return 0;
};

export const second_to_time = function (sec) {
  let hours = Math.floor(sec / 3600),
    minutes = Math.floor((sec % 3600) / 60),
    seconds = Math.floor((sec % 3600) % 60);
  const hours_str = hours === 0 ? "" : hours + ":";
  const minutes_str = minutes.toString().length < 2 ? "0" + minutes : minutes;
  const seconds_str = seconds.toString().length < 2 ? "0" + seconds : seconds;
  // example of time's format that return; is: '1:01:02' ,or if hours is zero: '01:02'
  return hours_str + minutes_str + ":" + seconds_str;
};

// record media api
// get permission and active access to the MediaDevices
export const getUserMedia = (constraints) => {
  if (navigator.mediaDevices) {
    return navigator.mediaDevices.getUserMedia(constraints);
  } else {
    // otherwise try falling back to old, possibly prefixed API...
    var legacyApi =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    if (legacyApi) {
      // ...and promisify it
      return new Promise((resolve, reject) => {
        legacyApi.bind(navigator)(constraints, resolve, reject);
      });
    } else {
      errorNotify({ text: "User Media API not supported." });
      return;
    }
  }
};

export const media_recorder = (stream, audio_type) => {
  // load this bundle only for browsers without MediaRecorder support
  if (!window.MediaRecorder) {
    throw new Error(
      "Audio recording with MediaRecorder is not supported in this browser"
    );
  }

  const mediaRecorder = new MediaRecorder(stream, { mimeType: audio_type });

  const canRecord = MediaRecorder.isTypeSupported(audio_type);

  if (!canRecord)
    throw new Error(
      "دستگاه شما توانایی ضبط صدا در قالب استاندارد ما را ندارد!"
    );

  return mediaRecorder;
};

//WebSocket connection function
export const websocket_connection = (
  url,
  onStartConnection,
  onMessage,
  onEndConnection
) => {
  let ws = new WebSocket(url);

  ws.onmessage = function (e) {
    const data = e.data;
    const obj_data = JSON.parse(data);
    onMessage(obj_data);
  };

  ws.onopen = function (e) {
    console.log("ws is open");
    onStartConnection();

    const token = getAuthToken();
    if (token) {
      ws.send(JSON.stringify({
        access_token: token
      }));
      console.log("Token sent to server via WebSocket");
    } else {
      console.warn("No auth token found in localStorage!");
    }
  };

  ws.onclose = function (e) {
    console.log("ws is closed");
    onEndConnection();
  };

  ws.onerror = function (e) {
    console.log("error", e);
    onEndConnection();
  };

  return ws;
};

export function convertToPersianNumber(number) {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  return String(number).replace(
    /\d/g,
    (match) => persianDigits[parseInt(match)]
  );
}
